import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/services-section/components/PageLoaderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/services-section/components/ServicesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/ParticleBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/ScrollIndicator.tsx");
